import { TableTemplateV2 } from "../dashboard/TableTemplate-v2";
import { TopReferralsDashboardTableWidgetFilters } from "../widget-filters/TopReferralsDashboardTableWidgetFilters";
import { TableWidget } from "./TableWidget";

export class TopReferralsDashboardTableWidget extends TableWidget {
    static getWidgetDashboardType() {
        return "Table";
    }

    static getWidgetMetadataType() {
        return "TopReferralsDashboardTable";
    }

    static getWidgetResourceType() {
        return "Table";
    }

    static getFiltersComponent() {
        return TopReferralsDashboardTableWidgetFilters;
    }

    constructor() {
        super();
    }

    public getSearchKey() {
        return "domain";
    }

    getProperties() {
        const props = super.getProperties();
        return props;
    }

    get templateUrl() {
        return `/app/components/widget/widget-templates/table.html`;
    }

    get templateComponent() {
        return TableTemplateV2;
    }

    _getProUrlParams() {
        const { filter = "", IncludeUrls, ExcludeUrls } = this.apiParams;
        return Object.assign(super._getProUrlParams(), {
            referralsCategory:
                typeof filter === "string" &&
                filter
                    .replace(/"/g, "")
                    .replace(",", "+")
                    .replace(/category;/g, ""),
            ExcludeUrls: ExcludeUrls,
            IncludeUrls: IncludeUrls,
        });
    }
}
TopReferralsDashboardTableWidget.register();
